import Vue from 'vue'
import _ from 'lodash'
import { formatDate, parseTime } from '../utils/time'
import { IMAGE_URL } from '../config'
import { getHtmlText, processQuesHtml } from './process-ques-html'
import { uppercaseNumber } from '../utils/uppercase-number'
import { encryptString } from '../utils/encrypt-string'

// 数字小写转大写
Vue.filter('uppercaseNumber', uppercaseNumber)

// 数字小写转大写
Vue.filter('romanNumber', (num) => {
  return 'ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ'.split('')[num]
})

Vue.filter('processQuesHtml', processQuesHtml)
Vue.filter('getHtmlText', getHtmlText)

Vue.filter('formatDate', formatDate)

// 注册过滤器
Vue.filter('formatRatio', (v) => {
  // 返回处理后的值
  return parseInt(v * 1000, 10) / 10 + '%'
})
Vue.filter('formatTime', (v, format) => {
  return parseTime(v, format)
})

// // 属性名称转换
// Vue.filter('grade2GradeLevel', function (v) {
//   // 返回处理后的值
//   return grade2GradeLevel(v)
// })
// 处理银行帐号  622202201444888888 => 6222 0220 1444 8888 88
Vue.filter('formatBankAccount', (v) => {
  let replaceSpaceArr = _.trim(v).replace(/\s/g, '').split('')
  return _.chunk(replaceSpaceArr, 4).join(' ').replace(/,/g, '')
})

const getToQuery = (item, toQuery) => {
  let filtered = {}
  let query = _.assign({}, toQuery)
  _.forOwn(query, (val, key) => {
    let value = item[val]
    if (value != null) {
      filtered[key] = value
    }
  })
  return filtered
}

Vue.filter('getToQuery', (item, toQuery) => {
  console.log(item, toQuery)
  return getToQuery(item, toQuery)
})

Vue.filter('encryptString', (val, start, end) => {
  // console.log('start, end', start, end)
  return encryptString(val, start, end)
})

Vue.filter('hidePhone', (val) => {
  return encryptString(val)
})

Vue.filter('formatAddressDetail', (item) => {
  return [item.province.regionname, item.city.regionname, item.region.regionname, item.address].join(' ')
})

Vue.filter('imgLink', (val) => {
  return IMAGE_URL + val
})

// 处理时间-连接2019-01-09 15:05:02
Vue.filter('formatTimeLine', (val) => {
  return parseTime(val)
})
// 处理时间-连接2019-01-09
Vue.filter('formatTimeDate', (val) => {
  return parseTime(val, '{y}-{m}-{d}')
})
